import { render, staticRenderFns } from "./Notifications.vue?vue&type=template&id=795b560c&scoped=true&"
import script from "./Notifications.vue?vue&type=script&lang=js&"
export * from "./Notifications.vue?vue&type=script&lang=js&"
import style0 from "./Notifications.vue?vue&type=style&index=0&id=795b560c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795b560c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/sapphire/K12Live16/build/CommunityWebPortal/_app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('795b560c')) {
      api.createRecord('795b560c', component.options)
    } else {
      api.reload('795b560c', component.options)
    }
    module.hot.accept("./Notifications.vue?vue&type=template&id=795b560c&scoped=true&", function () {
      api.rerender('795b560c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/Settings/Notifications/Notifications.vue"
export default component.exports